module.exports = __webpack_public_path__ + "img/Liliia.cde43745.jpeg";